import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { getURLPathname } from '../../../../../utils/parseURL';
import { WhyDuxBottomHeaderListItem, WhyDuxTopHeaderListItem } from '../../../../lists/items/header';

/**
 * @description Render memoized Why Dux content dropdown component
 * @param {Object} activeMenuContent
 * @param {Function} onExpandedMenuMouseEnter
 * @returns {JSX.Element} Memoized Why Dux content dropdown component
 */
export const WhyDuxContentDropdown = memo(function MemoizedWhyDuxContentDropdown({
  activeMenuContent,
  onExpandedMenuMouseEnter
}) {
  if (!activeMenuContent) {
    return null;
  }

  const topCount = activeMenuContent?.contentLink?.expanded?.itemsPerRowTop || 1;
  const bottomCount = activeMenuContent.contentLink.expanded?.itemsPerRowBottom || 3;

  return (
    <div className="primary-navigation__list">
      {!!activeMenuContent.contentLink.expanded?.subMenusTop?.length && (
        <ul
          className={`primary-navigation__list--count-${topCount}`}
          data-items-id={activeMenuContent?.contentLink?.expanded?.id || null}
        >
          {activeMenuContent.contentLink.expanded.subMenusTop
            .filter(
              (item2) =>
                item2 && Object.prototype.toString.call(item2) === '[object Object]' && Object.keys(item2)?.length > 0
            )
            .map((item2, index2) => {
              const updatedItem = Object.assign({}, item2);

              return (
                <WhyDuxTopHeaderListItem
                  key={updatedItem?.contentLink?.expanded?.contentLink?.id || index2}
                  item={updatedItem?.contentLink?.expanded || null}
                  count={topCount}
                  onExpandedMenuMouseEnter={onExpandedMenuMouseEnter}
                />
              );
            })}
        </ul>
      )}

      {!!activeMenuContent.contentLink.expanded?.subMenusBottom?.length && (
        <ul
          className={`primary-navigation__list--count-${bottomCount}`}
          data-items-id={activeMenuContent.contentLink.expanded?.id || null}
        >
          {activeMenuContent.contentLink.expanded.subMenusBottom
            .filter(
              (item2) =>
                item2 && Object.prototype.toString.call(item2) === '[object Object]' && Object.keys(item2)?.length > 0
            )
            .map((item2, index2) => {
              const updatedItem = Object.assign({}, item2);

              return (
                <WhyDuxBottomHeaderListItem
                  key={updatedItem?.contentLink?.expanded?.contentLink?.id || index2}
                  item={updatedItem?.contentLink?.expanded || null}
                  count={bottomCount}
                  onExpandedMenuMouseEnter={onExpandedMenuMouseEnter}
                />
              );
            })}
        </ul>
      )}

      {!!activeMenuContent.contentLink.expanded?.showAllLinkBottom?.url &&
        activeMenuContent.contentLink.expanded?.showAllLinkBottom?.text && (
          <div className="primary-navigation__list-cta">
            <Link
              to={getURLPathname(activeMenuContent.contentLink.expanded.showAllLinkBottom.url || '#')}
              className="btn btn--primary btn--small"
              onClick={(e) =>
                onExpandedMenuMouseEnter(
                  e,
                  getURLPathname(activeMenuContent.contentLink.expanded.showAllLinkBottom.url || '#')
                )
              }
            >
              <span>{activeMenuContent.contentLink.expanded.showAllLinkBottom.text || ''}</span>
            </Link>
          </div>
        )}
    </div>
  );
});

WhyDuxContentDropdown.propTypes = {
  activeMenuContent: PropTypes.object,
  onExpandedMenuMouseEnter: PropTypes.func
};
